import React from 'react';

import {hooks} from '../hooks';
import {CreationType} from '../types';
import {components} from '../components';
import {Routes} from '../routes';
  
type Props = {
  index: number;
  creation: CreationType;
  isLast: boolean;
};

export const CreationItem: React.FC<Props> = ({index, creation, isLast}) => {
  const navigate = hooks.useNavigate();

  return (
    <>
    <div
      style={{
        padding: 14,
        paddingTop: 14,
        paddingBottom: 14,
        borderRadius: 10,
        position: 'relative',
        marginBottom: 15,
        backgroundColor: 'var(--white-color)',
        display: 'block',
        height: 'auto',
        maxHeight: "100%",
      }}
      onClick={() => navigate(`/detail-creation/${creation.id}`, {state: {creation}})}
    >
      <div>
        <img
          src={creation.banner}
          alt={creation.title}
          style={{width: '100%', borderRadius: 6, objectFit: 'cover', height: 160}}
        />
        <div className='row-center-space-between' style={{paddingTop: 10}}>
          <h4 className='number-of-lines-2' style={{padding: '6px 0 0 0'}}>{creation.title}</h4>
        </div>
      </div>
      {/* <components.Name
        son={son.name}
        containerStyle={{marginBottom: 3}}
      /> */}
      <div style={{width: '100%'}}>
        <p className='t12 number-of-lines-3' style={{marginBottom: 10, overflow: 'hidden', paddingTop: 10}}>{creation.description}</p>
      </div>
    </div>
    </>
  );
};
